<template>
    <ThemeCard :theme="cardType === 'offline' ? 'primary' : 'default'">
        <template v-slot:title>
            <div class="title-container">
                <span>{{ title }}</span>
                <span v-if="deadline">{{ deadline }}</span>
            </div>
        </template>
        <template v-slot:content>
            <div class="theme-img-content">
                <div class="img-wrapper">
                    <img
                        v-for="(imgUrl, index) in imgUrls"
                        :key="index"
                        :style="{
                            'width': imgWidth ?? 'auto',
                            'height': imgHeight ?? 'auto',
                        }"
                        :src="imgUrl"
                        @click="onClickImg()"
                        v-b-toggle.sidebar-PIG />
                </div>
                
                <div v-if="imgDesc" class="img-desc mt-auto">
                    {{ imgDesc }}
                </div>
            </div>
        </template>
    </ThemeCard>
</template>

<script>
export default {
    props: ["cardType", "deadline", "imgDesc", "imgs", "title", "imgWidth", "imgHeight"],

    computed: {
        imgUrls() {
            return this.imgs.reduce((accu, curr) => {
                if (!curr.isShowOnPanel) return accu;

                return curr.type === "single"
                    ? [...accu, curr.url]
                    : curr.type === "list"
                    ? [...accu, ...curr.list]
                    : accu;
            }, []);
        }
    },

    methods: {
        onClickImg() {
            this.$emit("onClickImg", this.imgs);
        }
    },
};
</script>

<style scoped lang="scss">
@import "../style/photoGalleryCard.scss";
</style>
